/**
 * @file NotFoundComponent.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import "./PageNotFound.css"
import Typography from "@mui/material/Typography";
import { GoHomeButtonTheme, NotFoundSubTitleTheme, NotFoundTitleTheme } from "./NotFoundTheme";
import { Button } from "@mui/material";
import { Navigate } from "react-router-dom";
import { LoginHeaderView } from "../headers/views/LoginHeaderView";
import { BaseComponent } from "../home/base/BaseComponent";
import { BaseProps } from "../home/base/BaseProps";

/**
 * A type of Component state
 */
type CompState = { submitted: boolean };

/**
 * A class definition for NotFoundComponent
 */
export class NotFoundComponent extends BaseComponent<BaseProps, CompState> {

   constructor(props: BaseProps){
      super(props);
      this.state  = {
         submitted : false
      }
      this.logger.verbose("NotFoundComponent initialized", NotFoundComponent.name);
   }

   /**
    * Goes to home page
    */
   private goHome = ()=> {
      this.setState({
         submitted: true
     })
   }

   render() {
      return <React.Fragment>
                  {this.state.submitted && <Navigate to="/" replace={true}></Navigate>}
                  <LoginHeaderView />
                  <div className="NotPageFoundBox">
                     <img alt="complex" src="/../notfound.svg" />
                     <ThemeProvider theme={NotFoundTitleTheme}>
                        <Typography>{"404. We're sorry, page not found"} </Typography>
                     </ThemeProvider>
                     <ThemeProvider theme={NotFoundSubTitleTheme}>
                        <Typography>{"The page you are looking for doesn't exist or an other error occurred."}</Typography>
                     </ThemeProvider>
                     <ThemeProvider theme={GoHomeButtonTheme}>
                                             <Button onClick={this.goHome} className="GoToHomeButtom" size="small">Go to Dashboard</Button>
                                       </ThemeProvider>
                  </div>
            </React.Fragment>
   }
}